import { forwardRef, type ReactNode } from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "@/components/ui/cn";

type VCheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  label?: ReactNode;
};

export const VCheckbox = forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  VCheckboxProps
>(({ className, label, id, ...props }, ref) => (
  <label
    className={cn(
      "inline-flex items-start gap-2 text-sm",
      props.disabled ? "cursor-not-allowed" : "cursor-pointer",
    )}
    htmlFor={id}
  >
    <CheckboxPrimitive.Root
      ref={ref}
      id={id}
      className={cn(
        "peer mt-0.5 size-4 shrink-0 rounded border border-input bg-card shadow-sm",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        "data-[state=checked]:bg-primary-600 data-[state=checked]:border-primary-600 data-[state=checked]:text-on-primary",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        <Check className="size-3.5" strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
    {label ? <span className="text-foreground">{label}</span> : null}
  </label>
));
VCheckbox.displayName = "VCheckbox";

export type { VCheckboxProps };
